<div class="flex flex-col w-full h-full bg-white overflow-hidden">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <div class="flex justify-between items-start p-6 border-b border-gray-200">
    <div class="flex items-center gap-4 min-w-0">
      <div
        class="w-14 h-14 rounded-full bg-gray-200 flex items-center justify-center shrink-0"
      >
        <span class="text-base font-semibold text-gray-700">
          {{ initials }}
        </span>
      </div>

      <div class="flex flex-col min-w-0">
        <span
          class="text-xs text-purple-700 bg-purple-50 px-3 py-1 rounded-full w-fit mb-2"
        >
          Customer Profile
        </span>

        <h2 class="text-xl md:text-2xl font-semibold text-gray-900 truncate">
          {{ fullName }}
        </h2>

        <p class="text-sm text-gray-600 truncate">
          {{ customer?.email || "No email on file" }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="w-9 h-9 rounded-full border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50"
      (click)="close()"
    >
      ×
    </button>
  </div>

  <div
    class="grid grid-cols-2 md:grid-cols-4 gap-3 p-6 border-b border-gray-200"
  >
    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Lifetime Value</span>
      <strong class="text-lg md:text-xl font-semibold text-gray-900">
        {{ toMoney(lifetimeValue) }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Total Visits</span>
      <strong class="text-lg md:text-xl font-semibold text-gray-900">
        {{ totalVisits }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Average Spend</span>
      <strong class="text-lg md:text-xl font-semibold text-gray-900">
        {{ toMoney(averageSpend) }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Loyalty</span>
      <strong class="text-lg md:text-xl font-semibold text-gray-900">
        {{ loyaltyStatus }}
      </strong>
    </div>
  </div>

  <div class="flex gap-2 overflow-x-auto p-4 border-b border-gray-200 bg-white">
    <button
      *ngFor="let tab of tabs"
      type="button"
      class="px-4 py-2 rounded-3xl border text-sm whitespace-nowrap"
      [class.bg-gray-950]="activeTab === tab.key"
      [class.text-white]="activeTab === tab.key"
      [class.border-gray-950]="activeTab === tab.key"
      [class.bg-white]="activeTab !== tab.key"
      [class.text-gray-700]="activeTab !== tab.key"
      [class.border-gray-200]="activeTab !== tab.key"
      (click)="setTab(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>

  <main class="flex-1 overflow-y-auto p-6 bg-white">
    @if (activeTab === "overview") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Contact Details
          </h3>

          <div class="grid gap-3">
            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Phone</span>
              <strong class="text-sm text-gray-900 break-words">
                {{ customer?.phone_number || "Not added" }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Birthday</span>
              <strong class="text-sm text-gray-900">
                {{ formatDate(customer?.birthday, "MMM D") }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Last Visit</span>
              <strong class="text-sm text-gray-900">
                {{ formatDate(customer?.last_visit) }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Member Level</span>
              <strong class="text-sm text-gray-900">
                {{
                  customer?.member_Level || customer?.member_level || "Bronze"
                }}
              </strong>
            </div>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Customer Health
          </h3>

          <div class="grid gap-3">
            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Risk Status</span>
              <strong class="text-sm text-gray-900">
                {{ riskStatus }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">
                Visit Frequency
              </span>
              <strong class="text-sm text-gray-900">
                {{ visitFrequency }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">
                Suggested Follow-Up
              </span>
              <p class="text-sm text-gray-600 leading-6">
                {{ getFollowUpSuggestion() }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="md:col-span-2 bg-white border border-gray-200 rounded-lg p-5"
        >
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Service Preferences
          </h3>

          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let service of preferredServices"
              class="px-2 py-1 rounded-full bg-purple-50 text-purple-700 text-xs"
            >
              {{ service }}
            </span>
          </div>
        </div>
      </section>
    }

    @if (activeTab === "visits") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Past Visits
        </h3>

        @if (pastVisits.length) {
          <div class="grid gap-4">
            <article
              *ngFor="let visit of pastVisits"
              class="grid grid-cols-[18px_1fr] gap-3"
            >
              <div
                class="w-3 h-3 rounded-full bg-purple-600 shadow-[0_0_0_5px_#f5f3ff] mt-1"
              ></div>

              <div class="border-b border-gray-100 pb-4">
                <strong class="block text-sm text-gray-900">
                  {{ visit.salon_name || visit.salon?.name || "Salon visit" }}
                </strong>

                <p class="text-sm text-gray-600 pt-1">
                  {{
                    formatDate(
                      visit.start_time || visit.date,
                      "MMM D, YYYY h:mm A"
                    )
                  }}
                </p>

                <span class="text-xs text-purple-700 font-medium">
                  {{ visit.status || "Completed" }} ·
                  {{ toMoney(visit.total_price || visit.amount || 0) }}
                </span>
              </div>
            </article>
          </div>
        } @else {
          <div class="text-center py-8">
            <p class="text-gray-500">No past visits have been recorded yet.</p>
          </div>
        }
      </section>
    }

    @if (activeTab === "services") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Service Booking History
        </h3>

        @if (serviceHistory.length) {
          <div class="grid gap-3">
            <article
              *ngFor="let service of serviceHistory"
              class="flex justify-between gap-4 border border-gray-200 rounded-lg p-4"
            >
              <div>
                <strong class="block text-sm text-gray-900">
                  {{ service.name || service.service_name || service }}
                </strong>
                <p class="text-sm text-gray-600 pt-1">
                  Last booked:
                  {{ formatDate(service.last_booked || service.date) }}
                </p>
              </div>

              <span
                class="h-fit px-2 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-medium"
              >
                {{ service.count || service.total_bookings || 1 }} bookings
              </span>
            </article>
          </div>
        } @else {
          <div class="text-center py-8">
            <p class="text-gray-500">No service history available yet.</p>
          </div>
        }
      </section>
    }

    @if (activeTab === "notes") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Relationship Notes
        </h3>

        <textarea
          [(ngModel)]="noteDraft"
          rows="10"
          class="w-full rounded-lg border border-gray-200 bg-white p-4 text-sm outline-none focus:border-gray-950"
          placeholder="Add customer preferences, conversation notes, allergies, favorite staff, preferred times, dislikes, rebooking reminders..."
        ></textarea>

        <div class="flex justify-end pt-4">
          <button
            type="button"
            class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
            (click)="saveNotes()"
          >
            Save Notes
          </button>
        </div>
      </section>
    }

    @if (activeTab === "insights") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            CRM Insights
          </h3>

          <div class="grid gap-3">
            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">Best Segment</span>
              <strong class="text-sm text-gray-900">
                {{ loyaltyStatus }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">
                Rebooking Status
              </span>
              <strong class="text-sm text-gray-900">
                {{ riskStatus }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1"
                >Average Spend</span
              >
              <strong class="text-sm text-gray-900">
                {{ toMoney(averageSpend) }}
              </strong>
            </div>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Next Best Action
          </h3>

          <p class="text-sm text-gray-600 leading-6">
            {{ getFollowUpSuggestion() }}
          </p>
        </div>
      </section>
    }
  </main>
</div>
